/* Dev-only diagnostic logger — silent in production builds. */
export const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.debug(...args);
  }
};
